import type { SelectOption } from '../../../components/SelectCustom'
import type { ShopMessageKey } from '../../../i18n'
import { ORDER_SORT_OPTIONS } from './ordersListShared'

type TranslateFn = (key: ShopMessageKey, params?: Record<string, string | number>) => string

export const buildOrderSortOptions = (t: TranslateFn): SelectOption[] =>
  ORDER_SORT_OPTIONS.map((option) => {
    const label =
      option === 'recent-desc'
        ? t('customer.orders.sort.recent')
        : option === 'recent-asc'
          ? t('customer.orders.sort.oldest')
          : option === 'price-desc'
            ? t('customer.orders.sort.priceDesc')
            : t('customer.orders.sort.priceAsc')
    return {
      value: option,
      label,
    }
  })

export const buildOrderDateFilterOptions = (t: TranslateFn): SelectOption[] => [
  { value: 'all', label: t('customer.orders.filters.date.all') },
  { value: 'last-30-days', label: t('customer.orders.filters.date.last30') },
  { value: 'last-3-months', label: t('customer.orders.filters.date.last3Months') },
  { value: 'last-year', label: t('customer.orders.filters.date.lastYear') },
  { value: 'custom', label: t('customer.orders.filters.date.custom') },
]
